var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 44.8936C28 44.8936 29.6985 44.6509 36.7279 37.6215C43.7574 30.592 43.7574 19.1951 36.7279 12.1656C34.2374 9.67509 31.1986 8.06694 28 7.34121M28 44.8936H40M28 44.8936L28 32.8936M20 4.89394C20 4.89394 18.3015 5.13659 11.2721 12.166C4.24264 19.1955 4.24264 30.5924 11.2721 37.6219C13.7626 40.1124 16.8014 41.7206 20 42.4463M20 4.89394L8 4.89355M20 4.89394L20 16.8936",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.8a29e43a576266066f5a8356f83054b0.svg";
export { ForwardRef as ReactComponent };